import React, { useEffect, useMemo, useState } from "react";
import "./reportList.scss";
import ReportService from "../../services/Report/report.service";
import AppLoader from "../../shared/components/AppLoader";
import { Report } from "../../models/Report/report.model";
import { useHistory } from "react-router-dom";
import { AppRoutes } from "../../routes/routeConstants/appRoutes";
import { Button, Col, Input, Row, Table } from "antd";
import moment from "moment";
import AppCard from "../../shared/components/AppCard";
import { PlusOutlined } from "@ant-design/icons";

export const ReportList = () => {
    const [reports, setReports] = useState<Report[]>([]);

    const [searchText, setSearchText] = useState<string>("");

    const [newReportLoading, setNewReportLoading] = useState(false);

    const [loading, setLoading] = useState(false);

    const history = useHistory();

    const filteredReports = useMemo(() => {
        return reports.filter((report) =>
            report.reportId?.toString().includes(searchText) ||
            report.reportTitle?.toLowerCase().includes(searchText.toLowerCase())
        );
    }, [reports, searchText]);

    useEffect(() => {
        setLoading(true);
        ReportService.fetchDirectReports((reports: Report[]) => {
            setReports(reports);
        }, () => {

        }, () => {
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        const header = document.querySelector(".app-header") as HTMLElement;
        if (header) {
            header.style.display = "none";
        }
    }, [history.location.pathname]);

    const reportColumns = [
        {
            title: 'Report ID',
            dataIndex: 'reportId',
            key: 'reportId',
        },
        {
            title: 'Title',
            dataIndex: 'reportTitle',
            key: 'reportTitle',
            render: (reportTitle: string) => (
                reportTitle || 'N/A'
            ),
        },
        {
            title: 'Updated at',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            render: (updatedAt: string) => (
                updatedAt ? moment(updatedAt).format('DD/MM/YYYY') : ''
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_: any, record: Report) => (
                <Button 
                    type="link"
                    onClick={() => history.push(`${AppRoutes.REPORTS_LIST}/${record?.reportId}`)}
                >
                    View Report
                </Button>
            ),
        },
    ];

  const handleAddNewReport = () => {
    const report = new Report();
    report.content = '';
    report.aiPlugin = true;
    setNewReportLoading(true);
    ReportService.createReport(
      report,
      (report: Report) => {
        history.push(`${AppRoutes.REPORTS_LIST}/${report?.id}`);
      },
      () => {},
      () => {
        setNewReportLoading(false);
      }
    );
  };

    return (
    <div className="reports">
        {
            loading ? <AppLoader loading={loading}/> :
            <AppCard>
                <Row className="reports__header" align="middle">
                    <Col span={12}>
                        <h2>Reports</h2>
                    </Col>
                    <Col  span={12} className="text-right">
                        <Button 
                            icon={<PlusOutlined />}
                            type="primary" 
                            loading={newReportLoading}
                            onClick={handleAddNewReport}
                        >
                            Create New Report
                        </Button>
                    </Col>
                </Row>
                <Input.Search
                    className="reports__search-input"
                    placeholder="Search Reports"
                    allowClear
                    onChange={(e) => {
                        setSearchText(e.target.value);
                    }}
                />
                <Table 
                    dataSource={filteredReports} 
                    rowKey="id"
                    pagination={{ pageSize: 10 }} 
                    columns={reportColumns}
                    scroll={{ x: 'max-content' }}
                />
            </AppCard>

        }
    </div>
    );
};

